import * as jsxRuntime from "/codebuild/output/src522760307/src/TELUASEGHSITETEST/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment